/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transparent_Png_Or_Svg_512x51Inputs */

const en_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent PNG or SVG. 512x512px recommended for high-DPI displays.`)
};

const es_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG o SVG transparente. Recomendado 512x512px para pantallas de alta resolución.`)
};

const fr_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG ou SVG transparent. 512x512px recommandé pour les écrans haute définition.`)
};

const de_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparentes PNG oder SVG. 512x512px empfohlen für High-DPI-Displays.`)
};

const ja_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景透過のPNGまたはSVG。高DPIディスプレイ用には512x512pxを推奨します。`)
};

const zh_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透明 PNG 或 SVG 格式。高 DPI 显示器推荐使用 512x512px。`)
};

const ar_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صورة شفافة بصيغة PNG أو SVG. يُنصح بمقاس 512x512 بكسل لشاشات الدقة العالية.`)
};

const id_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG atau SVG transparan. Disarankan ukuran 512x512px untuk layar DPI tinggi.`)
};

const it_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG trasparente o SVG. Si consiglia 512x512px per display ad alta risoluzione.`)
};

const ru_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный PNG или SVG. Для экранов с высоким разрешением рекомендуется 512x512px.`)
};

const pt_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG transparente ou SVG. 512x512px recomendado para telas de alta densidade.`)
};

const ko_transparent_png_or_svg_512x51 = /** @type {(inputs: Transparent_Png_Or_Svg_512x51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`투명 배경의 PNG 또는 SVG. 고해상도 디스플레이를 위해 512x512px를 권장합니다.`)
};

/**
* | output |
* | --- |
* | "Transparent PNG or SVG. 512x512px recommended for high-DPI displays." |
*
* @param {Transparent_Png_Or_Svg_512x51Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const transparent_png_or_svg_512x51 = /** @type {((inputs?: Transparent_Png_Or_Svg_512x51Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transparent_Png_Or_Svg_512x51Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_transparent_png_or_svg_512x51(inputs)
	if (locale === "es") return es_transparent_png_or_svg_512x51(inputs)
	if (locale === "fr") return fr_transparent_png_or_svg_512x51(inputs)
	if (locale === "de") return de_transparent_png_or_svg_512x51(inputs)
	if (locale === "ja") return ja_transparent_png_or_svg_512x51(inputs)
	if (locale === "zh") return zh_transparent_png_or_svg_512x51(inputs)
	if (locale === "ar") return ar_transparent_png_or_svg_512x51(inputs)
	if (locale === "id") return id_transparent_png_or_svg_512x51(inputs)
	if (locale === "it") return it_transparent_png_or_svg_512x51(inputs)
	if (locale === "ru") return ru_transparent_png_or_svg_512x51(inputs)
	if (locale === "pt") return pt_transparent_png_or_svg_512x51(inputs)
	return ko_transparent_png_or_svg_512x51(inputs)
});